// // <----- numero 3 bouganville "il gelso" su air b&b ----->
// // cucina bouganville
import bouganvillecucina1 from "../../images/villagrecoimmagini/3-Bouganville/cucina/1.webp"
import bouganvillecucina2 from "../../images/villagrecoimmagini/3-Bouganville/cucina/2.jpg"
import bouganvillecucina3 from "../../images/villagrecoimmagini/3-Bouganville/cucina/3.jpg"
import bouganvillecucina4 from "../../images/villagrecoimmagini/3-Bouganville/cucina/4.jpg"
import bouganvillecucina5 from "../../images/villagrecoimmagini/3-Bouganville/cucina/5.jpg"
import bouganvillecucina6 from "../../images/villagrecoimmagini/3-Bouganville/cucina/6.jpg"
import bouganvillecucina7 from "../../images/villagrecoimmagini/3-Bouganville/cucina/7.jpg"
// // matrimoniale bouganville
import bouganvillematrimoniale6 from "../../images/villagrecoimmagini/3-Bouganville/matrimoniale/6.webp"
// matrimoniale manu modifica
import bouganvillematrimonialeEmanuela1 from "../../images/villagrecoimmagini/3-Bouganville/matrimoniale/modificaEmanuela/1.jpg"
import bouganvillematrimonialeEmanuela2 from "../../images/villagrecoimmagini/3-Bouganville/matrimoniale/modificaEmanuela/2.jpg"
import bouganvillematrimonialeEmanuela4 from "../../images/villagrecoimmagini/3-Bouganville/matrimoniale/modificaEmanuela/4.jpg"
import bouganvillematrimonialeEmanuela5 from "../../images/villagrecoimmagini/3-Bouganville/matrimoniale/modificaEmanuela/5.jpg"

// //bagno bouganville
import bouganvillebagno1 from "../../images/villagrecoimmagini/3-Bouganville/bagno/1.webp"
import bouganvillebagno4 from "../../images/villagrecoimmagini/3-Bouganville/bagno/4.jpg"

// //esterno bouganville
import bouganvillesterno1 from "../../images/villagrecoimmagini/3-Bouganville/esterno/1.jpg"
import bouganvillesterno2 from "../../images/villagrecoimmagini/3-Bouganville/esterno/2.jpg"

//------------------------------------------------------------------------------------------------------------------------------------------------------------------
// // <----- numero 4 il gelso ----->
// // cucina il gelso
import ilgelsocucina1 from "images/villagrecoimmagini/4-IlGelso/cucina/1.webp"
import ilgelsocucina2 from "images/villagrecoimmagini/4-IlGelso/cucina/2.webp"
import ilgelsocucina3 from "images/villagrecoimmagini/4-IlGelso/cucina/3.jpg"
import ilgelsocucina4 from "images/villagrecoimmagini/4-IlGelso/cucina/4.jpg"
import ilgelsocucina5 from "images/villagrecoimmagini/4-IlGelso/cucina/5.jpg"
// // matrimoniale il gelso
import ilgelsomatrimoniale1 from "images/villagrecoimmagini/4-IlGelso/matrimoniale/1.webp"
import ilgelsomatrimoniale4 from "images/villagrecoimmagini/4-IlGelso/matrimoniale/4.webp"
import ilgelsomatrimoniale6 from "images/villagrecoimmagini/4-IlGelso/matrimoniale/6.webp"
import ilgelsomatrimoniale7 from "images/villagrecoimmagini/4-IlGelso/matrimoniale/7.webp"
import ilgelsomatrimoniale8 from "images/villagrecoimmagini/4-IlGelso/matrimoniale/8.jpg"
import ilgelsomatrimoniale10 from "images/villagrecoimmagini/4-IlGelso/matrimoniale/10.jpg"
// modifiche in più manu
import ilgelsoMatrimonialeEmanuela1 from "images/villagrecoimmagini/4-IlGelso/matrimoniale/matrimonialeEmanuela/1.jpg"
import ilgelsoMatrimonialeEmanuela2 from "images/villagrecoimmagini/4-IlGelso/matrimoniale/matrimonialeEmanuela/2.jpg"
import ilgelsoMatrimonialeEmanuela3 from "images/villagrecoimmagini/4-IlGelso/matrimoniale/matrimonialeEmanuela/3.jpg"
// bagno il gelso
import ilgelsobagno2 from "images/villagrecoimmagini/4-IlGelso/bagno/2.webp"

// altre immagini gelso
import altre1 from "images/villagrecoimmagini/4-IlGelso/Altre/1.webp"
import altre4 from "images/villagrecoimmagini/4-IlGelso/Altre/4.jpg"

//------------------------------------------------------------------------------------------------------------------------------------------------------------------
// <----- numero 5 A casa di peppino ----->
// cucina peppino
import peppinocucina1 from "images/villagrecoimmagini/5-aCasaDiPeppino/cucina/1.webp"
import peppinocucina2 from "images/villagrecoimmagini/5-aCasaDiPeppino/cucina/2.webp"
import peppinocucina3 from "images/villagrecoimmagini/5-aCasaDiPeppino/cucina/3.webp"
import peppinocucina12 from "images/villagrecoimmagini/5-aCasaDiPeppino/cucina/12.webp"

// matrimoniale peppino
import peppinoMatrimoniale2 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/2.webp"
import peppinoMatrimoniale3 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/3.webp"
import peppinoMatrimoniale4 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/4.webp"
import peppinoMatrimoniale5 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/5.webp"
import peppinoMatrimoniale6 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/6.webp"
import peppinoMatrimoniale11 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/11.webp"
import peppinoMatrimoniale12 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/12.webp"
import peppinoMatrimoniale13 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/13.webp"
import peppinoMatrimoniale14 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/14.webp"
import peppinoMatrimoniale16 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/16.webp"
import peppinoMatrimoniale17 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/17.webp"
import peppinoMatrimoniale18 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/18.webp"
import peppinoMatrimoniale20 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/20.webp"
import peppinoMatrimoniale21 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/21.webp"
import peppinoMatrimoniale24 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/24.webp"
import peppinoMatrimoniale27 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/27.webp"
import peppinoMatrimoniale30 from "images/villagrecoimmagini/5-aCasaDiPeppino/matrimoniale/30.webp"

// bagno peppino
import peppinoBagno3 from "images/villagrecoimmagini/5-aCasaDiPeppino/bagno/3.webp"
// letto singolo peppino
import lettiSingoliPeppino1 from "images/villagrecoimmagini/5-aCasaDiPeppino/lettosingolo/1.webp"
import lettiSingoliPeppino3 from "images/villagrecoimmagini/5-aCasaDiPeppino/lettosingolo/3.webp"
import lettiSingoliPeppino5 from "images/villagrecoimmagini/5-aCasaDiPeppino/lettosingolo/5.webp"
import lettiSingoliPeppino7 from "images/villagrecoimmagini/5-aCasaDiPeppino/lettosingolo/7.webp"

// altre immagini peppino
import altrePeppino1 from "images/villagrecoimmagini/5-aCasaDiPeppino/altre/1.webp"
import altrePeppino2 from "images/villagrecoimmagini/5-aCasaDiPeppino/altre/2.webp"
import altrePeppino4 from "images/villagrecoimmagini/5-aCasaDiPeppino/altre/4.webp"
// altre immagini aggiunte insieme a menu
import altrePeppino5 from "images/villagrecoimmagini/5-aCasaDiPeppino/altre/5.webp"
import altrePeppino6 from "images/villagrecoimmagini/5-aCasaDiPeppino/altre/6.webp"
import altrePeppino8 from "images/villagrecoimmagini/5-aCasaDiPeppino/altre/8.webp"

//------------------------------------------------------------------------------------------------------------------------------------------------------------------
// // <----- numero 6 L'ulivo ----->
// cucina L'ulivo
import ulivocucina1 from "images/villagrecoimmagini/6-LUlivo/cucina/1.webp"
import ulivocucina2 from "images/villagrecoimmagini/6-LUlivo/cucina/2.webp"
import ulivocucina3 from "images/villagrecoimmagini/6-LUlivo/cucina/3.webp"
import ulivocucina4 from "images/villagrecoimmagini/6-LUlivo/cucina/4.webp"
import ulivocucina5 from "images/villagrecoimmagini/6-LUlivo/cucina/5.jpg"
import ulivocucina6 from "images/villagrecoimmagini/6-LUlivo/cucina/6.jpg"
import ulivocucina7 from "images/villagrecoimmagini/6-LUlivo/cucina/7.jpg"
import ulivocucina8 from "images/villagrecoimmagini/6-LUlivo/cucina/8.jpg"
import ulivocucina9 from "images/villagrecoimmagini/6-LUlivo/cucina/9.jpg"
import ulivocucina10 from "images/villagrecoimmagini/6-LUlivo/cucina/10.jpg"
// matrimoniale L'ulivo
import ulivoMatrimoniale1 from "images/villagrecoimmagini/6-LUlivo/matrimoniale/1.webp"
import ulivoMatrimoniale6 from "images/villagrecoimmagini/6-LUlivo/matrimoniale/6.webp"
import ulivoMatrimoniale8 from "images/villagrecoimmagini/6-LUlivo/matrimoniale/8.webp"
import ulivoMatrimoniale9 from "images/villagrecoimmagini/6-LUlivo/matrimoniale/9.webp"
import ulivoMatrimoniale10 from "images/villagrecoimmagini/6-LUlivo/matrimoniale/10.jpg"
import ulivoMatrimoniale11 from "images/villagrecoimmagini/6-LUlivo/matrimoniale/11.jpg"
//modifiche emanuela
import ulivoMatrimonialeEmanuela1 from "images/villagrecoimmagini/6-LUlivo/matrimoniale/matrimonialeManuela/1.jpg"
import ulivoMatrimonialeEmanuela2 from "images/villagrecoimmagini/6-LUlivo/matrimoniale/matrimonialeManuela/2.jpg"
import ulivoMatrimonialeEmanuela3 from "images/villagrecoimmagini/6-LUlivo/matrimoniale/matrimonialeManuela/3.jpg"
// bagno L'ulivo
import ulivoBagno1 from "images/villagrecoimmagini/6-LUlivo/bagno/1.webp"
import ulivoBagno2 from "images/villagrecoimmagini/6-LUlivo/bagno/2.webp"
import ulivoBagno5 from "images/villagrecoimmagini/6-LUlivo/bagno/5.jpg"
// l'ulivo immagini fuori
import ulivoFuroi8 from "images/villagrecoimmagini/6-LUlivo/fuori/8.jpg"
import ulivoFuori9 from "images/villagrecoimmagini/6-LUlivo/fuori/9.jpg"
import ulivoFuori10 from "images/villagrecoimmagini/6-LUlivo/fuori/10.jpg"
import ulivoFuori11 from "images/villagrecoimmagini/6-LUlivo/fuori/11.jpg"

//------------------------------------------------------------------------------------------------------------------------------------------------------------------

// foto giardino generale da usare ovunque
import fotoGeneraliGiardino1 from "images/villagrecoimmagini/generale/giardinoGenerali/1.webp"
import fotoGeneraliGiardino2 from "images/villagrecoimmagini/generale/giardinoGenerali/2.webp"
import fotoGeneraliGiardino3 from "images/villagrecoimmagini/generale/giardinoGenerali/3.jpg"
import fotoGeneraliGiardino4 from "images/villagrecoimmagini/generale/giardinoGenerali/4.jpg"
import fotoGeneraliGiardino5 from "images/villagrecoimmagini/generale/giardinoGenerali/5.jpg"
import fotoGeneraliGiardino6 from "images/villagrecoimmagini/generale/giardinoGenerali/6.jpg"
import fotoGeneraliGiardino7 from "images/villagrecoimmagini/generale/giardinoGenerali/7.jpg"
import fotoGeneraliGiardino8 from "images/villagrecoimmagini/generale/giardinoGenerali/8.jpg"
import fotoGeneraliGiardino9 from "images/villagrecoimmagini/generale/giardinoGenerali/9.jpg"
import fotoGeneraliGiardino10 from "images/villagrecoimmagini/generale/giardinoGenerali/10.webp"
import fotoGeneraliGiardino11 from "images/villagrecoimmagini/generale/giardinoGenerali/11.jpg"
import fotoGeneraliGiardino12 from "images/villagrecoimmagini/generale/giardinoGenerali/12.jpg"

const indirizzo = process.env.REACT_APP_INDIRIZZO
const nomeHost = process.env.REACT_APP_HOSTNOMECOMPLETO
const immagineHost = process.env.REACT_APP_IMMAGINEEMANUELA

const numeroReviewsConStelle = 5.0
const numeroReviews = 20

export const STANZE_REALI = [
  //------------------------------------------------- A casa di bouganville in Villa Greco N3 -------------------------------------------------
  {
    id: "3",
    author: {
      id: 1,
      name: nomeHost,
      avatarUrl: immagineHost,
    },
    date: "23 Novembre 2024",
    href: "/stanze/belvedere",
    title: "Bouganville in Villa Greco",
    featuredImage: "https://i.ibb.co/2Yb39mw/1.jpg",
    galleryImgs: [
      // prima vista max 5 immagini
      bouganvillematrimonialeEmanuela2,
      bouganvillecucina1,
      bouganvillematrimonialeEmanuela5,
      bouganvillebagno1,
      bouganvillematrimonialeEmanuela4,

      // nuove foto manu
      bouganvillematrimonialeEmanuela1,

      // cucina
      bouganvillecucina3,
      bouganvillecucina2,
      bouganvillecucina4,
      bouganvillecucina5,
      bouganvillecucina6,
      bouganvillecucina7,

      // matrimoniale
      bouganvillematrimoniale6,

      // bagno
      bouganvillebagno4,

      // esterno
      bouganvillesterno1,
      bouganvillesterno2,

      ulivoFuori10,
      ulivoFuori11,
      fotoGeneraliGiardino11,
      fotoGeneraliGiardino12,
    ],
    commentCount: 12,
    viewCount: 105,
    like: true,
    address: indirizzo,
    reviewStart: numeroReviewsConStelle,
    reviewCount: numeroReviews,
    price: "300€",
    maxGuests: 2,
    bedrooms: 1,
    bathrooms: 1,
    saleOff: false,
    isAds: null,
    map: { lat: 45.464211, lng: 9.191383 },

    description: `Miniappartamento, appena ristrutturato, ideale come punto di appoggio per una vacanza all’insegna del relax immersi nel verde!
Fatevi coccolare dai suoni, gli odori e i colori che solo questo luogo regala, rilassatevi in questo spazio tranquillo immerso all'interno di un vasto giardino privato che regala panorami unici sulle Isole Eolie, i Laghetti di Marinello e Capo MiIazzo.
Vi troverete in pieno centro storico a due passi dal Teatro Greco e dal Santuario della Madonna Nera.`,

    description2: `Miniappartamento, appena ristrutturato, completamente arredato e molto luminoso.
Dispone di un angolo cottura e zona pranzo che si affaccia su un terrazzino privato a vostro uso esclusivo, una comoda stanza da letto matrimoniale, un bagno con doccia.
Avrete inoltre a disposizione un vasto giardino esterno, ricco di vegetazione, dotato di parcheggio, zone relax, barbecue.`,

    description3: `L'accesso alla struttura è facile e comodo, troverete un cancello dedicato che vi permetterà di entrare nel giardino all'interno del quale è posizionata la struttura. L’ampio giardino con zone relax sarà a vostra completa disposizione. Il parcheggio è interno e gratuito.`,

    description4: `L'uso del climatizzatore è a pagamento, regolato da un contatore che consente di pagare solo il consumo effettivo. |
    Animali domestici ammessi su richiesta (con supplemento). |
    È vietato fumare all'interno, ma è possibile utilizzare le aree esterne dedicate.  |
    Il parcheggio (gratuito) interno è illuminato, garantendo sicurezza e comodità per i vostri veicoli.  |
    L'accesso è consentito solo agli ospiti registrati, non sono ammesse feste o eventi. |
    La fascia oraria del silenzio è dalle 14:00 alle 16:00.  |
    Check-in: 16:00 in poi Check-out: entro le 10:00. |
    Per qualsiasi necessità o informazione, saremo a vostra disposizione.  |
    L'orario di check-in è flessibile, ma è necessario concordarlo in anticipo.`,

    description5: `IT083066C222IAFD28`,

    optional: [
      { name: "Condizionatore / Pompa di calore", icon: "las la-snowflake" },
      { name: "Ventilatore", icon: "las la-fan" },
      { name: "Wi-Fi", icon: "las la-wifi" },
      { name: "Tv", icon: "las la-tv" },
      { name: "Stendino", icon: "las la-tshirt" },
      { name: "Bollitore", icon: "las la-coffee" },
      { name: "Parcheggio", icon: "las la-parking" },
      { name: "Asciugacapelli", icon: "las la-wind" },
    ],
  },
  //------------------------------------------------- A il gelso in Villa Greco N4 -------------------------------------------------
  {
    id: "4",
    author: {
      id: 1,
      name: nomeHost,
      avatarUrl: immagineHost,
    },
    date: "23 Novembre 2024",
    href: "/stanze/belvedere",
    title: "Il gelso in Villa Greco",
    featuredImage: "https://i.ibb.co/KLJpmLs/20241120-164501.jpg",
    galleryImgs: [
      // prima vista max 5 immagini
      ilgelsoMatrimonialeEmanuela1,
      fotoGeneraliGiardino4,
      ilgelsocucina1,
      ilgelsocucina4,
      ilgelsobagno2,

      // matrimoniale
      ilgelsoMatrimonialeEmanuela3,
      ilgelsomatrimoniale4,
      ilgelsomatrimoniale6,
      ilgelsomatrimoniale7,
      ilgelsomatrimoniale8,
      ilgelsomatrimoniale10,
      ilgelsoMatrimonialeEmanuela2,
      // cucina
      ilgelsocucina2,
      ilgelsocucina3,
      ilgelsocucina5,
      // altre
      altre4,
      // altre1,

      // esterno
      bouganvillesterno1,
      bouganvillesterno2,

      // giardino generali
      fotoGeneraliGiardino1,
      fotoGeneraliGiardino2,
      fotoGeneraliGiardino3,
      fotoGeneraliGiardino5,
      fotoGeneraliGiardino6,
      fotoGeneraliGiardino7,
      fotoGeneraliGiardino8,
      fotoGeneraliGiardino9,
      ulivoFuori10,
      ulivoFuori11,
      fotoGeneraliGiardino11,
      fotoGeneraliGiardino12,
      fotoGeneraliGiardino6,
    ],
    commentCount: 12,
    viewCount: 105,
    like: true,
    address: indirizzo,
    reviewStart: numeroReviewsConStelle,
    reviewCount: numeroReviews,
    price: "400€",
    maxGuests: 2,
    bedrooms: 1,
    lettinoExtra: 1,
    bathrooms: 1,
    saleOff: false,
    isAds: null,
    map: { lat: 45.464211, lng: 9.191383 },

    description: `Rilassati in questo spazio tranquillo in posizione centrale. L’appartamento è ideale come punto di appoggio per una vacanza all’insegna del relax immersi nel verde! Il vasto giardino regala panorami unici, dalle isole Eolie agli spettacolari laghetti di Marinello. Fatevi coccolare dai suoni, gli odori e i colori che solo questo luogo regala!`,
    // description2: `L' appartamento si trova in pieno centro storico del piccolo borgo di Tindari. A pochi passi si trova il Santuario della Madonna Nera, e le splendide rovine dell'antica Tindari con la sua rinomata zona archeologica. Poco distante dalla struttura si trova lo spettacolare percorso naturalistico Coda di Volpe che, costeggiando la collina, conduce direttamente alla riserva naturale dei Laghetti di Marinello. A soli 7 minuti di auto si raggiunge la spiaggia di Mongiove con le sue spettacolari grotte naturali, oppure la dorata spiaggia di Oliveri e i laghetti di Marinello. A pochi minuti di auto potrete raggiungere il centro di Patti con la sua bella Cattedrale e la sua maestosa Villa Romana. Poco distanti troverete Milazzo con il suo Castello e il suo bel centro storico, il piccolo borgo di Montalbano Elicona, Cefalù e la splendida Taormina`,

    description2: `L'appartamento, appena ristrutturato, completamente arredato, molto luminoso, dispone di una cucina con zona pranzo, una comoda stanza da letto matrimoniale, un bagno con doccia.
    Su richiesta è possibile aggiungere un letto singolo.
    Avrete inoltre a disposizione un vasto giardino esterno, ricco di vegetazione, dotato di parcheggio, zone relax (arredate con tavoli, sedie e sdraio), barbecue.
    `,

    description3: `L'accesso alla struttura è facile e comodo, troverete un cancello dedicato che vi permetterà di entrare nel giardino all'interno del quale è posizionata la struttura. L’ampio giardino con zone relax sarà a vostra completa disposizione. Il parcheggio è interno e gratuito.`,

    description4: `L'uso del climatizzatore è a pagamento, regolato da un contatore che consente di pagare solo il consumo effettivo. |
    Animali domestici ammessi su richiesta (con supplemento). |
    È vietato fumare all'interno, ma è possibile utilizzare le aree esterne dedicate.  |
    Il parcheggio (gratuito) interno è illuminato, garantendo sicurezza e comodità per i vostri veicoli.  |
    L'accesso è consentito solo agli ospiti registrati, non sono ammesse feste o eventi. |
    La fascia oraria del silenzio è dalle 14:00 alle 16:00.  |
    Check-in: 16:00 in poi Check-out: entro le 10:00. |
    Per qualsiasi necessità o informazione, saremo a vostra disposizione.  |
    L'orario di check-in è flessibile, ma è necessario concordarlo in anticipo.`,

    description5: `IT083066C222IAFD28`,

    optional: [
      { name: "Condizionatore / Pompa di calore", icon: "las la-snowflake" },
      { name: "Ventilatore", icon: "las la-fan" },
      { name: "Wi-Fi", icon: "las la-wifi" },
      { name: "Tv", icon: "las la-tv" },
      { name: "Stendino", icon: "las la-tshirt" },
      { name: "Bollitore", icon: "las la-coffee" },
      { name: "Parcheggio", icon: "las la-parking" },
      { name: "Asciugacapelli", icon: "las la-wind" },
      { name: "Lettino Aggiuntivo su richiesta", icon: "las la-bed" },
    ],
  },
  //------------------------------------------------- A casa di Peppino in Villa Greco N5 -------------------------------------------------
  {
    id: "5",
    author: {
      id: 1,
      name: nomeHost,
      avatarUrl: immagineHost,
    },
    date: "23 Novembre 2024",
    href: "/stanze/belvedere",
    title: "A casa di Peppino in Villa Greco",
    featuredImage: peppinocucina1,
    galleryImgs: [
      // prima vista max 5 immagini
      peppinoMatrimoniale4,
      peppinocucina1,
      altrePeppino2,
      peppinoMatrimoniale11,
      lettiSingoliPeppino5,
      peppinoMatrimoniale5,

      // cucina
      peppinocucina2,
      peppinocucina3,
      peppinocucina12,

      // matrimoniale
      peppinoMatrimoniale2,
      peppinoMatrimoniale3,

      peppinoMatrimoniale6,
      peppinoMatrimoniale12,
      peppinoMatrimoniale13,
      peppinoMatrimoniale14,
      peppinoMatrimoniale16,
      peppinoMatrimoniale17,
      peppinoMatrimoniale18,
      peppinoMatrimoniale20,
      peppinoMatrimoniale21,
      peppinoMatrimoniale24,
      peppinoMatrimoniale27,
      peppinoMatrimoniale30,

      // letto singolo
      lettiSingoliPeppino1,
      lettiSingoliPeppino3,
      lettiSingoliPeppino5,
      lettiSingoliPeppino7,

      // bagno
      peppinoBagno3,

      // altre
      altrePeppino1,
      altrePeppino4,

      // giardino generali
      fotoGeneraliGiardino1,
      fotoGeneraliGiardino2,
      fotoGeneraliGiardino4,
      fotoGeneraliGiardino5,
      fotoGeneraliGiardino8,
      fotoGeneraliGiardino9,
      fotoGeneraliGiardino10,
      altrePeppino5,
      altrePeppino6,
      altrePeppino8,

      ulivoFuori11,
      fotoGeneraliGiardino11,
      fotoGeneraliGiardino12,
    ],
    commentCount: 12,
    viewCount: 105,
    like: true,
    address: indirizzo,
    reviewStart: numeroReviewsConStelle,
    reviewCount: numeroReviews,
    price: "500€",
    maxGuests: 4,
    bedrooms: 1,
    lettiSingoli: 2,
    bathrooms: 1,
    saleOff: false,
    isAds: null,
    map: { lat: 45.464211, lng: 9.191383 },
    description: `Ampio e accogliente appartamento per 4 persone provvisto di terrazzino esterno coperto dove potersi rilassare e godersi momenti di pace!
L'alloggio si trova all'interno di un vasto giardino privato in pieno centro storico a due passi dal Teatro Greco e dal Santuario della Madonna nera.
Il panorama è unico! Potrete ammirare le splendide isole Eolie, i meravigliosi laghetti di Marinello e Capo Milazzo.
Le rovine della zona archeologica fanno da cornice a questo splendido luogo.`,

    description2: `L'appartamento è composto da un'ampia cucina / soggiorno, due comode camere da letto, di cui una con letto matrimoniale e una con due letti singoli.
Vi è poi un corridoio e un bagno con comoda doccia e lavatrice.
La casa dispone di un terrazzo privato e coperto che si affaccia sull'ampio giardino a disposizione degli ospiti con zone relax, ampi spazi verdi con parcheggio interno.`,

    description3: `L'accesso alla struttura è facile e comodo, troverete un cancello dedicato che vi permetterà di entrare nel giardino all'interno del quale è posizionata la struttura. L’ampio giardino con zone relax sarà a vostra completa disposizione. Il parcheggio è interno e gratuito.`,

    description4: `L'uso del climatizzatore è a pagamento, regolato da un contatore che consente di pagare solo il consumo effettivo. |
    Animali domestici ammessi su richiesta (con supplemento). |
    È vietato fumare all'interno, ma è possibile utilizzare le aree esterne dedicate.  |
    Il parcheggio (gratuito) interno è illuminato, garantendo sicurezza e comodità per i vostri veicoli.  |
    L'accesso è consentito solo agli ospiti registrati, non sono ammesse feste o eventi. |
    La fascia oraria del silenzio è dalle 14:00 alle 16:00.  |
    Check-in: 16:00 in poi Check-out: entro le 10:00. |
    Per qualsiasi necessità o informazione, saremo a vostra disposizione.  |
    L'orario di check-in è flessibile, ma è necessario concordarlo in anticipo.`,

    description5: `IT083066C2NJTWNQCJ`,

    optional: [
      { name: "Condizionatore / Pompa di calore", icon: "las la-snowflake" },
      { name: "Wi-Fi", icon: "las la-wifi" },
      { name: "Tv", icon: "las la-tv" },
      { name: "Stendino", icon: "las la-tshirt" },
      { name: "Bollitore", icon: "las la-coffee" },
      { name: "Parcheggio", icon: "las la-parking" },
      { name: "Asciugacapelli", icon: "las la-wind" },
      { name: "Lavatrice", icon: "las la-fan" },
    ],
  },
  //------------------------------------------------- L'ulivo in Villa Greco N6 -------------------------------------------------
  {
    id: "6",
    author: {
      id: 1,
      name: nomeHost,
      avatarUrl: immagineHost,
    },
    date: "23 Novembre 2024",
    href: "/stanze/belvedere",
    title: "L'ulivo in Villa Greco",
    featuredImage: ulivocucina1,
    galleryImgs: [
      // ulivoMatrimonialeEmanuela1,

      // prima vista max 5 immagini
      ulivoMatrimoniale8,
      ulivoMatrimoniale1,
      ulivocucina9,
      ulivoMatrimonialeEmanuela3,
      ulivoFuori9,
      ulivocucina8,
      ulivoMatrimoniale11,

      // cucina
      ulivocucina1,
      ulivocucina2,
      ulivocucina3,
      ulivocucina4,
      ulivocucina5,
      ulivocucina6,
      ulivocucina7,
      ulivocucina10,

      // matrimoniale
      ulivoMatrimoniale6,
      ulivoMatrimoniale9,
      ulivoMatrimoniale10,
      ulivoMatrimonialeEmanuela2,

      // bagno
      ulivoBagno1,
      ulivoBagno2,
      ulivoBagno5,

      // fuori
      ulivoFuroi8,
      ulivoFuori10,
      ulivoFuori11,
      fotoGeneraliGiardino11,
      fotoGeneraliGiardino12,
    ],
    commentCount: 12,
    viewCount: 105,
    like: true,
    address: indirizzo,
    reviewStart: numeroReviewsConStelle,
    reviewCount: numeroReviews,
    price: "600€",
    maxGuests: 2,
    bedrooms: 1,
    bathrooms: 1,
    lettinoExtra: 1,
    saleOff: false,
    isAds: null,
    map: { lat: 45.464211, lng: 9.191383 },
    description: `Ampio e accogliente appartamento di recente costruzione, ubicato a piano terra all'interno di un vasto giardino completamente recintato, con parcheggio interno, zone relax , barbecue, per godervi momenti di pace.
Il panorama è unico! Potrete ammirare le splendide isole Eolie, i meravigliosi laghetti di Marinello e Capo Milazzo.
Sarete in pieno centro storico a due passi dal Teatro Greco e dal Santuario della Madonna nera. La zona archeologica farà da cornice a questo splendido luogo.`,

    description2: `L’appartamento, sito a piano terra, dispone di un’ampia cucina / soggiorno, una camera da letto luminosa dove, su richiesta, può essere aggiunto un terzo letto, un bagno con doccia e lavatrice.
    L'appartamento si trova all’interno di un vasto giardino secolare a disposizione degli ospiti, con parcheggio interno, 
     zone relax e barbecue.`,

    description3: `L'accesso alla struttura è facile e comodo, troverete un cancello dedicato che vi permetterà di entrare nel giardino all'interno del quale è posizionata la struttura. L’ampio giardino con zone relax sarà a vostra completa disposizione. Il parcheggio è interno e gratuito.`,

    description4: `L'uso del climatizzatore è a pagamento, regolato da un contatore che consente di pagare solo il consumo effettivo. |
    Animali domestici ammessi su richiesta (con supplemento). |
    È vietato fumare all'interno, ma è possibile utilizzare le aree esterne dedicate.  |
    Il parcheggio (gratuito) interno è illuminato, garantendo sicurezza e comodità per i vostri veicoli.  |
    L'accesso è consentito solo agli ospiti registrati, non sono ammesse feste o eventi. |
    La fascia oraria del silenzio è dalle 14:00 alle 16:00.  |
    Check-in: 16:00 in poi Check-out: entro le 10:00. |
    Per qualsiasi necessità o informazione, saremo a vostra disposizione.  |
    L'orario di check-in è flessibile, ma è necessario concordarlo in anticipo.`,

    description5: `IT083066C2NTSW2WHA`,

    optional: [
      { name: "Condizionatore / Pompa di calore", icon: "las la-snowflake" },
      { name: "Wi-Fi", icon: "las la-wifi" },
      { name: "Tv", icon: "las la-tv" },
      { name: "Stendino", icon: "las la-tshirt" },
      { name: "Bollitore", icon: "las la-coffee" },
      { name: "Parcheggio", icon: "las la-parking" },
      { name: "Asciugacapelli", icon: "las la-wind" },
      { name: "Lavatrice", icon: "las la-fan" },
      { name: "Lettino Aggiuntivo su richiesta", icon: "las la-bed" },
    ],
  },
]
